import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@Shared/components/general/page-header.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { LOAD_DOCUMENTS } from "../store/document-actions";
import { COMPLETED_CLASSIFICATIONS, OUTSTANDING_CLASSIFICATIONS } from "../store/document-getters";
import DocumentClassificationCollapse from "./document-classification-collapse.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import DocumentsLoader from "./documents-loader.vue";
import RefreshButton from "@Shared/components/buttons/refresh-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentsContainer",
  title() {
    return this.$t("sidebar.sections.documents");
  },
  components: {
    DocumentClassificationCollapse,
    PageHeader,
    DocumentsLoader,
    RefreshButton
  },
  data() {
    return {
      loading: true,
      refreshing: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["selectedApplicationId"])), mapState("DocumentStore", {
    classifications(state) {
      return state.classifications.byApplication[this.selectedApplicationId];
    },
    documents(state) {
      return state.documents.byApplication[this.selectedApplicationId];
    },
    comments(state) {
      return state.comments.byApplication[this.selectedApplicationId];
    }
  })), mapGetters("DocumentStore", [COMPLETED_CLASSIFICATIONS, OUTSTANDING_CLASSIFICATIONS])), {}, {
    completedClassifications() {
      return this.COMPLETED_CLASSIFICATIONS(this.selectedApplicationId);
    },
    outstandingClassifications() {
      return this.OUTSTANDING_CLASSIFICATIONS(this.selectedApplicationId);
    }
  }),
  beforeCreate() {
    Amplitude.logEvent("Documents - visited", {
      page: "documents"
    });
  },
  async mounted() {
    this.loading = true;
    await this.LOAD_DOCUMENTS({
      applicationId: this.selectedApplicationId
    });
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentStore", [LOAD_DOCUMENTS])), {}, {
    async refreshDocuments() {
      this.refreshing = true;
      await this.LOAD_DOCUMENTS({
        applicationId: this.selectedApplicationId
      });
      this.refreshing = false;
    }
  })
});